import { AppBar, Toolbar } from "@mui/material";

const HeaderBar = () => {
  return (
    <AppBar class="App-header">
      <Toolbar>
        <h2>もちっとカフェ</h2>
      </Toolbar>
    </AppBar>
  );
};

const Header = (props) => {
  const loading = props.loading;
  const setLoading = props.setLoading;
  const loadingHandler = () => {
    setTimeout(() => setLoading(false), 4000);
  };

  return (
    <>
      {!loading && (
        <header className="header">
          <HeaderBar />
        </header>
      )}
      <div
        style={loading ? { display: "none" } : {}}
        className="header-img"
        onLoad={loadingHandler()}
      />
    </>
  );
};

export default Header;
